module.exports = __webpack_public_path__ + "static/media/master.29cbd0e2.svg";